import { MutationTree } from 'vuex';
import { BookState } from '@/store/types/book.state';

export const mutations: MutationTree<BookState> = {
    setDisplayingChapter(state, value) {
        state.displayingChapter = value;
    },
    setSliderHue(state, value) {
        state.sliderHue = value;
    },
    setSliderLuminance(state, value) {
        state.sliderLuminance = value;
    },
    setNOctaves(state, value) {
        state.nOctaves = value;
    },
    setBaseHue(state, value) {
        state.baseHue = value;
    },
    setAttack(state, value) {
        state.attack = value;
    },
};

